import { React, useState } from "react";
import { useTranslation } from "react-i18next";
import tournamentlist from "../../../images/tournamentlist.png";
import Diamond from "../../../images/Diamond.png"
import arrow from "../../../images/rightside.png"
import moment from 'moment';
import { url } from "../../../config/url";
import { useNavigate } from "react-router";
import { toastInfo } from '../../../Utilities/toast'

const TournamentBox = ({ children, item, setIsRulesPopup, setPricePointPool, getjoin }) => {
  const [isInputVisible, setIsInputVisible] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const totalPlayers = item?.totalPlayers || 0; // Example total number of players
  const joinedPlayers = item?.totalJoinedPlayers || 0; // Example number of players who have joined
  const remainingPlayers = totalPlayers - joinedPlayers;

  const percentage = (joinedPlayers / totalPlayers) * 100; // Calculate percentage
  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };

  return (
    <>
      <div>
        <div className="container tournament-card--wrap mt-4">

          <div className="tournament-card mb-4">

            <div className="card-body d-flex flex-column justify-content-between">
              <div className="d-flex justify-content-between align-items-center">
                <div className="card-title">
                  {item?.title?.length > 18 ? (
                    // scrolldelay="200" for delay marquee
                    <marquee >
                      {item?.title}
                    </marquee>
                  ) : (
                    item?.title
                  )}
                  {/* {item?.title} */}
                </div>
                <button className="btn rules-btn" onClick={() => setIsRulesPopup(item?._id)}>{t('tournament_list.rules')}</button>
              </div>
              <hr style={{ margin: "0.5rem 0" }}></hr>
              <div className="row">
                <div className="col-3 pe-0 tournament-img">
                  <div className="tournament-img--wapr">
                    <img src={`${url.IMAGE_URL}${item?.featuredImage?.default}`} alt="game" className="rounded" />
                    <span className="tournament-img--data">{item?.gameTypeAry?.name}</span>
                  </div>
                </div>

                <div className="col-9 ps-1">
                  <div className="tournament-card-detail">
                    {
                      item?.titles?.[1]?.isSelection ?
                      <>
                      <div className="row">
                      <div className="col-12 tournament-card-box--wrap mb-2">
                        <div className="row">
                          <div className="col-4 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label letter-spacing">
                                {moment(item?.startDate).format('DD/MM/YYYY')}
                              </div>
                              <div className="tournament-detail-value">
                                {t('tournament_list.date')}
                              </div>
                            </div>
                          </div>
                          <div className="col-4 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label">{item?.roundsCount || 0}</div>
                              <div className="tournament-detail-value">
                                {t('tournament_list.round')}
                              </div>
                            </div>
                          </div>
                          <div className="col-4 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label" onClick={() => {
                                navigator.clipboard.writeText(
                                  item?.shortCode
                                );
                                toastInfo('short code copied')
                              }}>
                                {item?.shortCode}
                              </div>
                              <div className="tournament-detail-value">{t('tournament_list.id')}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 tournament-card-box--wrap">
                        <div className="row">
                          {item?.titles?.[0]?.isSelection && item?.titles?.[0]?.name && item?.titles?.[0]?.value &&
                            <div className="col-4 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.titles?.[0]?.value.length > 8 ? (

                                    <marquee >
                                      {item?.titles?.[0]?.value}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[0]?.value
                                  )}
                                  {/* {item?.titles?.[0]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                  {item?.titles?.[0]?.name.length > 8 ? (

                                    <marquee >
                                      {item?.titles?.[0]?.name}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[0]?.name
                                  )}
                                  {/* {item?.titles?.[0]?.name} */}
                                </div>
                              </div>
                            </div>
                          }
                          {item?.titles?.[1]?.isSelection && item?.titles?.[1]?.name && item?.titles?.[1]?.value &&
                            <div className="col-4 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.titles?.[1]?.value.length > 11 ? (

                                    <marquee >
                                      {item?.titles?.[1]?.value}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[1]?.value
                                  )}
                                  {/* {item?.titles?.[1]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                  {item?.titles?.[1]?.name.length > 11 ? (

                                    <marquee >
                                      {item?.titles?.[1]?.name}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[1]?.name
                                  )}
                                  {/* {item?.titles?.[1]?.name} */}
                                </div>
                              </div>
                            </div>
                          }
                          {item?.killPoints &&
                            <div className="col-4 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.killPoints}
                                </div>
                                <div className="tournament-detail-value">{t('tournament_list.kills_point')}</div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                      </>
                      :
                      <>
                       <div className="row">
                      <div className="col-12 tournament-card-box--wrap mb-2">
                        <div className="row">
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label letter-spacing">
                                {moment(item?.startDate).format('DD/MM/YYYY')}
                              </div>
                              <div className="tournament-detail-value">
                                {t('tournament_list.date')}
                              </div>
                            </div>
                          </div>
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label">{item?.roundsCount || 0}</div>
                              <div className="tournament-detail-value">
                                {t('tournament_list.round')}
                              </div>
                            </div>
                          </div>
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label" onClick={() => {
                                navigator.clipboard.writeText(
                                  item?.shortCode
                                );
                                toastInfo('short code copied')
                              }}>
                                {item?.shortCode}
                              </div>
                              <div className="tournament-detail-value">{t('tournament_list.id')}</div>
                            </div>
                          </div>
                          {item?.titles?.[0]?.isSelection && item?.titles?.[0]?.name && item?.titles?.[0]?.value &&
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.titles?.[0]?.value.length > 8 ? (

                                    <marquee >
                                      {item?.titles?.[0]?.value}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[0]?.value
                                  )}
                                  {/* {item?.titles?.[0]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                  {item?.titles?.[0]?.name.length > 8 ? (

                                    <marquee >
                                      {item?.titles?.[0]?.name}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[0]?.name
                                  )}
                                  {/* {item?.titles?.[0]?.name} */}
                                </div>
                              </div>
                            </div>
                          }
                          {item?.titles?.[1]?.isSelection && item?.titles?.[1]?.name && item?.titles?.[1]?.value &&
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.titles?.[1]?.value.length > 11 ? (

                                    <marquee >
                                      {item?.titles?.[1]?.value}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[1]?.value
                                  )}
                                  {/* {item?.titles?.[1]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                  {item?.titles?.[1]?.name.length > 11 ? (

                                    <marquee >
                                      {item?.titles?.[1]?.name}
                                    </marquee>
                                  ) : (
                                    item?.titles?.[1]?.name
                                  )}
                                  {/* {item?.titles?.[1]?.name} */}
                                </div>
                              </div>
                            </div>
                          }
                          {item?.killPoints &&
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                  {item?.killPoints}
                                </div>
                                <div className="tournament-detail-value">{t('tournament_list.kills_point')}</div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                       
                    </div>
                      </>
                    }
                    

                   
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <div className="tournament-details-winnings">
                  <div className="d-flex justify-content-between">
                    <p className="prize-info">
                      {t('tournament_list.prize_pool')}
                      <span className="tournament-prizepool">{item?.prizePoolType === 'amount' ? item?.prizePool : item?.rewardDisplayText}
                        {
                          item?.prizePoolType === 'amount' &&
                          <img
                            className="currency-icon"
                            src={url?.IMAGE_URL + item?.currency?.[0]?.outCurrency?.img?.default}
                            alt=""
                          />
                        }
                      </span>
                    </p>
                    <p className="join-info">
                      {t('tournament_list.winners')} <span className="tournament-prizepool">{item?.totalWinners}
                        <div onClick={() => setPricePointPool(item?._id, item)}>
                          <svg xmlns="http://www.w3.org/2000/svg" class="tournament-arrow-icon" viewBox="0 0 20 20">
                            <path d="M5.83288 8.33326L9.99956 12.4999L14.16622 8.33326" />
                          </svg>
                        </div>
                      </span>
                    </p>
                    <p className="join-using">
                      {t('tournament_list.join_using')}
                      {item?.entryFee > 0 ? (
                        <span className="tournament-prizepool">{item?.entryFee || 0}
                          <img
                            className="currency-icon"
                            src={
                              url.IMAGE_URL +
                              item?.currency?.[0]?.inCurrency?.img?.default
                            }
                            alt=""
                          />
                        </span>
                      ) : (
                        <span className="tournament-prizepool">
                          {t('tournament_list.free')}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                {/* Progress Bar */}
                <div
                  className="progress"
                  style={{ height: "6px", width: "100%" }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${percentage}%`, // Dynamically set width
                      backgroundColor: "#9F6693", // Change color if 100%
                    }}
                    aria-valuenow={joinedPlayers}
                    aria-valuemin="0"
                    aria-valuemax={totalPlayers}
                  ></div>
                </div>
              </div>

              <p className="progressbar-text mt-2">
                <div>{joinedPlayers} {joinedPlayers > 1 ? t('tournament_list.players_joined') : t('tournament_list.player_joined')}</div>
                <div>{totalPlayers}</div>
              </p>
            </div>


            <div className="abs-btn--wrap">
              {item?.isJoined == false && remainingPlayers > 0 ? (
                <button className="join-now-btn" onClick={() => getjoin(item?._id, item)}>{t('tournament_list.join_now')}</button>
              ) : item?.isJoined === false && remainingPlayers === 0 ? (
                <button className="join-now-btn">{t('tournament_list.full')}</button>
              ) : (
                <button className="join-now-btn" onClick={() => navigate(`/tournament/details/${item?._id}`)}>{t('tournament_list.joined')}</button>
              )}
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </>
  );
};

export default TournamentBox;
